<template>
  <div>
    <div  v-if="voucher.cliente">
      <v-container fluid>
        <div class="text-h6 white--text d-md-none" style="margin-top: 10px;">Voucher de compra do<br />passaporte</div>
        <div class="text-h6 black--text d-none d-md-block" style="margin-top: 10px;">Voucher de compra do<br />passaporte</div>
      </v-container>
      <v-img src="/img/banner-1.jpg" height="150px" width="100%"></v-img>
      <v-container fluid>
          <div class="text-h5 font-weight-black">Voucher Parque {{ parques[voucher.parque].nome }}</div>
          <div class="text-subtitle-2">{{ parques[voucher.parque].endereco }}</div>
          <div class="text-subtitle-2">{{ parques[voucher.parque].telefone }}</div>
          <div style="background-color: white; padding: 2px;"><qrcode-vue class="text-center" :value="voucher.voucher" size="200" level="L" renderAs="canvas"></qrcode-vue></div>
          <v-btn block>
            <a @click="compartilhar()">Compartilhar via Whatsapp</a>
          </v-btn>
          <v-alert v-if="voucher.forma_pagamento == 1" color="red" type="success">Você deve apresentar o documento de identidade e o cartão utilizado nesta compra na hora da retirada das pulseiras de acesso</v-alert>
          <v-row>
            <v-col cols="9"><div class="text-h6">Nome</div></v-col>
            <v-col cols="3"><div class="text-h6">ID</div></v-col>
          </v-row>
          <v-row>
            <v-col cols="9"><div class="text-subtitle-1">{{ voucher.cliente.nome }}</div></v-col>
            <v-col cols="3"><div class="text-subtitle-1">#{{ voucher.id }}</div></v-col>
          </v-row>
          <div class="text-h6">Ingressos</div>
          <div v-for="(p, i) of voucher.produtos" :key="i">
            <div class="text-subtitle-1">{{ p.titulo }}</div>
            <div class="text-subtitle-2">{{ p.quantidade }}x {{ p.valorPromo | fmtNumber }} = R$ {{ p.total | fmtNumber }}</div>
          </div>
          <div class="text-h6 text-right">Total: R$ {{ voucher.valor | fmtNumber }}</div>
      </v-container>
    </div>
    <div v-else>
      <v-container fluid>
        <div class="text-h6 white--text d-md-none" style="margin-top: 10px;">Recibo de Pagamento</div>
        <div class="text-h6 black--text d-none d-md-block" style="margin-top: 10px;">Recibo de Pagamento</div>
      </v-container>
      <v-container>
      <div class="text-h5 font-weight-black">Recibo #{{ voucher.id }}</div>
        <qrcode-vue class="text-center" :value="voucher.voucher" size="200" level="L" renderAs="canvas"></qrcode-vue>
        <v-btn block>
          <a @click="compartilhar()">Compartilhar via Whatsapp</a>
        </v-btn>
        <v-row>
          <v-col cols="9"><div class="text-h6">Nome</div></v-col>
          <v-col cols="3"><div class="text-h6">Matrícula</div></v-col>
        </v-row>
        <v-row>
          <v-col cols="9"><div class="text-subtitle-1">{{ voucher.socio.nome }}</div></v-col>
          <v-col cols="3"><div class="text-subtitle-1">{{ voucher.socio.matricula }}</div></v-col>
        </v-row>
        <div class="text-h6">Detalhe</div>
        <div v-for="(p, i) of voucher.produtos" :key="i">
          <div class="text-subtitle-1">{{ p.titulo }}</div>
          <div class="text-subtitle-2">{{ p.quantidade }}x {{ p.valorPromo | fmtNumber }} = R$ {{ p.total | fmtNumber }}</div>
        </div>
        <div class="text-h6 text-right">Total: R$ {{ voucher.valor | fmtNumber }}</div>
    </v-container>
    </div>
  </div>
</template>
<style scoped>
.card-button {
  background-color: white;
  width: 100%;
  height: 150px !important;
}
</style>
<script>
import QrcodeVue from 'qrcode.vue'
import { mapState } from 'vuex'

export default {
  components: { QrcodeVue },
  computed: {
    ...mapState(['voucher', 'parques'])
  },
  methods: {
    compartilhar: function () {
      if (confirm('Você está prestes a compartilhar o voucher via whatsapp tem certeza?')) {
        window.location.href = 'https://wa.me/?text=' + encodeURI(window.location.origin + this.$router.history.current.fullPath)
      }
    }
  }
}
</script>
